import { useCallback } from 'react';
import { useSafeState } from './useSafeState';

type AsyncFunction = (...args: any[]) => Promise<any>;

export const useAsyncFunction = <F extends AsyncFunction>(fn?: F) => {
  const [isLoading, setIsLoading] = useSafeState(false);

  const wrappedFn = useCallback(
    (...args: Parameters<F>) =>
      Promise.resolve(setIsLoading(true))
        .then(() => fn?.(...args))
        .finally(() => setIsLoading(false)),
    [fn, setIsLoading],
  );

  return [wrappedFn, isLoading] as [F, boolean];
};
